import { css } from "@emotion/css";
import type { ArgoCDGatewayHealthStatus } from "@octopusdeploy/octopus-server-client";
import { GatewayInstallationStatus } from "~/areas/infrastructure/components/ArgoCDInstances/DialogViews/components/GatewayInstallationStatus";
type InstallationStatusViewProps = {
    healthStatus: ArgoCDGatewayHealthStatus;
    isFound: boolean;
};
export const InstallationStatusView = (props: InstallationStatusViewProps) => {
    const { healthStatus, isFound } = props;
    return (<div className={styles.contentContainer}>
            <GatewayInstallationStatus healthStatus={healthStatus} isFound={isFound}/>
        </div>);
};
const styles = {
    contentContainer: css({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        flex: "1 0 0",
        alignSelf: "stretch",
    }),
};
